import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';

export type AiCostLimitUsersFetchedAction = {
	type: 'AI_COST_LIMIT_USERS_FETCHED';
	payload: UserPayload[];
	accountId: number;
};

export default (payload: UserPayload[], accountId: number): AiCostLimitUsersFetchedAction => ({
	type: 'AI_COST_LIMIT_USERS_FETCHED',
	payload,
	accountId,
});
